export default __webpack_public_path__ + "static/media/contact.1b6efcb1.svg";